// libs
import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

export default class ShopItem extends React.Component {
    static propTypes = {
        disabled: PropTypes.bool,
        onClick: PropTypes.func,
        children: PropTypes.any,
        className: PropTypes.string
    }

    static defaultProps = {
        onClick: () => {},
        disabled: false,
        children: null,
        className: ''
    }

    handleClick = ( e ) => {
        const { onClick, disabled } = this.props;
        if ( !disabled ) {
            onClick( e );
        }
    }

    render() {
        const {
            onClick, // eslint-disable-line no-unused-vars
            disabled,
            children,
            className,
            ...props
        } = this.props;

        return (
            <li className={ classNames( 'shop-item', className, { 'has-no-anchor': disabled } ) } {...props}>
                { disabled ? (
                    children
                ) : (
                    <a
                        className={ classNames( 'shop-item-anchor', `${className}-anchor` ) }
                        href="#"
                        onClick={ this.handleClick }
                        aria-label="Shop"
                    >
                        { children }
                    </a>
                ) }
            </li>
        );
    }
}
